import { render, staticRenderFns } from "./editPermission.vue?vue&type=template&id=65422dbe&scoped=true&"
import script from "./editPermission.vue?vue&type=script&lang=js&"
export * from "./editPermission.vue?vue&type=script&lang=js&"
import style0 from "./editPermission.vue?vue&type=style&index=0&id=65422dbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65422dbe",
  null
  
)

export default component.exports